<template>
  <div>
    <component v-bind:is="headerComponent"></component>
    <div class="row-container mt5 ph3 footer__row-container">
      <h1 class="footer__title">{{ $t('contactCustomerService') }}</h1>
      <div class="footer__item-wrapper">
        <div class="footer__item footer__item--second">
          <h2 class="footer__subtitle">{{ $t('icf3PhoneTitle') }}</h2>
          <p class="footer__text">{{ $t('icf3PhoneSubtitle') }}</p>
          <button class="footer__item__link" @click="showPhoneModal">
            <h4 class="text">{{ $t('callUs') }}</h4>
          </button>
          <transition name="fade">
            <div
              v-if="isOpenPhoneModal"
              class="footer__item__modal"
              @mouseover="isHovering"
              @mouseleave="notHovering"
              v-on:blur="inputBlur"
            >
              <span class="footer__modal-exit-icon" @click="isOpenPhoneModal = !isOpenPhoneModal">&#88;</span>
              <div class="mt2 mb4">
                <h2 class="footer__modal-title">{{ $t('callUs') }}</h2>
                <a class="footer__modal-link db" :href="`tel:${localNumber}`">
                  <h2 class="footer__modal-link-text">{{ localNumber }} {{ $t('callNumberText1') }}</h2>
                </a>
              </div>

              <div class="mt2 mb3">
                <a class="footer__modal-link db" :href="`tel:+1-${internationalNumber}`">
                  <h2 class="footer__modal-link-text fw4 roboto fs24 mt0 mb0">
                    +1-{{ internationalNumber }} {{ $t('callNumberText2') }}
                  </h2>
                </a>
              </div>
            </div>
          </transition>
        </div>
        <!-- <div class="footer__line"></div> -->
        <div class="footer__item footer__item--third">
          <h2 class="footer__subtitle">{{ $t('icf3ChatTitle') }}</h2>
          <p class="footer__text">{{ $t('icf3ChatSubtitle') }}</p>
          <button class="footer__item__link" @click="showChatModal">
            <h4 class="text">{{ $t('startLiveChat') }}</h4>
          </button>
          <transition name="fade">
            <div
              v-if="isOpenChatModal"
              class="footer__item__modals"
              @mouseover="isHovering"
              @mouseleave="notHovering"
              v-on:blur="inputBlur"
            >
              <span class="footer__modal-exit-icon" @click="isOpenChatModal = !isOpenChatModal">&#88;</span>
              <div class="mt2 mb4">
                <h2 class="footer__modal-title">{{ $t('chatModalTitle') }}</h2>
                <h2 class="footer__modal-subtitle">{{ $t('chatModalSubTitle') }}</h2>
                <ul class="footer__modal-options">
                  <li class="footer__modal-option">
                    <a class="footer__modal-link" :href="chatLinkThree">{{ $t('popQues3') }}</a>
                  </li>
                  <li class="footer__modal-option">
                    <router-link
                      class="footer__modal-link"
                      :to="{
                        name: 'article',
                        hash: `#${$store.state.flowObject.variables.popularQuestions[0]}-${chatLinkOne.title.replace(
                          / /g,
                          '-'
                        )}`,
                      }"
                      >{{ $t('popQues1') }}</router-link
                    >
                  </li>
                  <li class="footer__modal-option">
                    <router-link
                      class="footer__modal-link"
                      :to="{
                        name: 'article',
                        hash: `#${$store.state.flowObject.variables.popularQuestions[1]}-${chatLinkTwo.title.replace(
                          / /g,
                          '-'
                        )}`,
                      }"
                      >{{ $t('popQues2') }}</router-link
                    >
                  </li>
                </ul>
                <h2 class="footer__modal-subtitle">{{ $t('chatModalSubTitleFooter') }}</h2>
                <div class="footer__modal-option">
                  <a @click="startChat" class="footer__modal-divnk">{{ $t('startChat') }}</a>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import Article from '@/components/article/zen_no_title';

import {
  getComponent,
  trackPageView,
  trackPageClick,
  getSpecificArticleFromStore,
  getCountryCode,
  available_countries,
  high_priority_countries,
  low_priority_countries,
} from '@/utils/common';

export default {
  name: 'requests',
  data() {
    return {
      phoneModalVisible: false,
      isOpenPhoneModal: false,
      isOpenChatModal: false,
      hovering: false,
      localNumberText: null,
      isTollFree: false,
      isPriority: false,
    };
  },
  created() {
    trackPageView('submit_request');
  },
  mounted() {},
  metaInfo() {
    return {
      titleTemplate: `${this.$t('requestTitle')} - %s `,
    };
  },
  components: { VueRecaptcha, Article },
  computed: {
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header');
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer');
    },
    internationalNumber() {
      return this.$store.state.siteDetails.support_number_us_canada;
    },
    localNumber() {
      this.localNumberText = this.getLocalNumber();
      return this.localNumberText;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    chatLinkOne() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[0]);
      return question || { title: '' };
    },
    chatLinkTwo() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[1]);
      return question || { title: '' };
    },
    chatLinkThree() {
      return `https://members.${this.$store.state.siteDetails.domain_name}/account/recovery`;
    },
  },
  methods: {
    startChat() {
      this.$gtm.dataLayer().push({
        event: 'Load Chatbot',
      });
      this.showChatModal();
    },
    trackPageClick,
    showPhoneModal() {
      this.isOpenPhoneModal = !this.isOpenPhoneModal;
      if (this.isOpenChatModal) {
        this.isOpenChatModal = !this.isOpenChatModal;
      }
    },
    showChatModal() {
      this.isOpenChatModal = !this.isOpenChatModal;
      if (this.isOpenPhoneModal) {
        this.isOpenPhoneModal = !this.isOpenPhoneModal;
      }
    },
    inputBlur() {
      if (!this.hovering) {
        this.isOpenPhoneModal = false;
      }
    },
    isHovering() {
      this.hovering = true;
    },
    notHovering() {
      this.hovering = false;
    },
    getLocalNumber() {
      // getCountryCode();

      let localNumber;
      let storedCountryCode = localStorage.getItem('country_code');
      // console.log(`storedCountryCode is... ${storedCountryCode}`);

      const getAvailableCountryList = available_countries;
      // console.log(`getAvailableCountryList is... ${getAvailableCountryList}`);
      const getHighPriorityCountryList = high_priority_countries;
      // console.log(`getHighPriorityCountryList is... ${getHighPriorityCountryList}`);
      const getLowPriorityCountryList = low_priority_countries;
      // console.log(`getLowPriorityCountryList is... ${getLowPriorityCountryList}`);

      // conditional logic to 'hide' 'local' number by changing 'isPriority' state
      if (getLowPriorityCountryList.indexOf(storedCountryCode) > -1) {
        this.isPriority = false;
        // console.log(`- isPriority is... ${this.isPriority}`)
      } else {
        this.isPriority = true;
        // console.log(`+ isPriority is... ${this.isPriority}`)
      }

      // define strings to check for
      let tollFreeString = this.$store.state.siteDetails.corp_info[`${storedCountryCode}_toll_free_number`];
      let paidPhoneString = this.$store.state.siteDetails.corp_info[`${storedCountryCode}_phone_number`];

      if (tollFreeString) {
        // if there's a 'toll-free' number from corp,...

        // display 'toll-free number' for 'us', 'ca' & 'it'
        if (storedCountryCode === 'us' || storedCountryCode === 'ca' || storedCountryCode === 'it') {
          this.isTollFree = true;

          localNumber = this.$store.state.siteDetails.corp_info[`${storedCountryCode}_toll_free_number`];
          localStorage.setItem('local_number', localNumber);
          return localNumber;
        }
      } else if (paidPhoneString) {
        // else if there's a regular (paid) number from corp,...

        // display 'uk toll-free number' for 'ru'
        if (storedCountryCode === 'ru') {
          localNumber = this.$store.state.siteDetails.corp_info.uk_toll_free_number;
          localStorage.setItem('local_number', localNumber);
          return localNumber;

          // display 'local number' for all others
        } else {
          localNumber = this.$store.state.siteDetails.corp_info[`${storedCountryCode}_phone_number`];
          localStorage.setItem('local_number', localNumber);
          return localNumber;
        }
      } else {
        // if there's neither or a mis-match.

        // display 'uk toll-free number' for 'uk'... mapped to 'gb'
        if (storedCountryCode === 'gb' || storedCountryCode === 'ru') {
          localNumber = this.$store.state.siteDetails.corp_info.uk_toll_free_number;
          localStorage.setItem('local_number', localNumber);
          return localNumber;

          // display 'es' after mapping to 'sp'
        } else if (storedCountryCode === 'es') {
          localNumber = this.$store.state.siteDetails.corp_info.sp_phone_number;
          localStorage.setItem('local_number', localNumber);
          return localNumber;

          // if there's no number from corp, display international (non-changing) number
        } else {
          localNumber = this.$store.state.siteDetails.corp_info.us_toll_free_number;
          localStorage.setItem('local_number', localNumber);
          return localNumber;
        }
      }
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped="true">
@import '@/styles/variables.scss';

.form {
  max-width: 650px;
}
.input-group {
  margin-bottom: 25px;

  .btn {
    background-color: #0072ef;
    border: 0;
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    line-height: 2.72;
    min-width: 190px;
    padding: 0 1.9286em;
    width: 100%;
    box-sizing: border-box;
    outline: none;
    transition: border 0.12s ease-in-out;
    cursor: pointer;

    @media (min-width: 768px) {
      width: auto;
    }
    &:hover,
    &:focus,
    &:active {
      background-color: #004189;
    }
  }
}
.input-group--btns {
  margin-top: 40px;
  padding-top: 30px;
}
.label {
  display: block;
  font-size: 13px;
  margin-bottom: 5px;
}
.input {
  border: 1px solid #ddd;
  border-radius: 4px;
  font-weight: 300;
  max-width: 100%;
  box-sizing: border-box;
  outline: none;
  transition: border 0.12s ease-in-out;
  font-size: 14px;
}
.textarea {
  border: 1px solid #ddd;
  border-radius: 2px;
  resize: vertical;
  width: 100%;
  outline: none;
  min-height: 120px;
}
.input,
.textarea {
  width: 100%;
  color: #000;
  font-size: 14px;
  padding: 10px;

  &:focus {
    border: 1px solid #0072ef;
  }
}
.input-group__fineprint {
  color: #676767;
  font-size: 12px;
  margin: 5px 0;
}

.searchbox {
  font-size: 13px;
  color: #676767;
  font-family: Roboto, Helvetica, Arial, sans-serif;
}
.sug-label {
  border-bottom: 1px solid #ddd;
  display: block;
  padding-bottom: 5px;
}

ul {
  list-style: none;
  padding-left: 0px;
}
.suggestion-list li {
  padding: 10px 0;
  box-sizing: border-box;
  a {
    text-decoration: none;
    color: rgba(59, 180, 239, 1);
    background-color: transparent;
  }
}
.fade-enter-active {
  transition: opacity 0.7s;
}
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.notification-inline.notification-error {
  background-color: #f4dfde;
  border: 1px solid #e03b30;
  color: #e03b30;
}
.notification {
  border: 1px solid;
  display: table;
  font-family: sans-serif;
  font-size: 12px;
  padding: 10px 15px 15px 15px !important;
  margin: 0px 0px 100px 0px !important;
  transition: height 0.2s;
  width: 100%;
  color: #555;
}
.notification-inline {
  border-radius: 4px;
  font-weight: 100;
  line-height: 14px;
  margin-top: 5px;
  padding: 5px;
  position: relative;
  text-align: left;
  vertical-align: middle;
}
.notification-error {
  background: #ffeded;
}
.notification-inline.notification-error::before {
  border-radius: 50%;
  border: 1px solid #e03b30;
  color: #e03b30;
  content: '!';
  display: inline-block;
  font-family: sans-serif;
  font-size: 8px;
  font-weight: normal;
  height: 12px;
  line-height: 12px;
  margin: -2px 5px 0 0;
  text-align: center;
  vertical-align: middle;
  width: 12px;
}
.flc::first-letter {
  text-transform: uppercase; /* change first letter to uppercase */
}
.show-err {
  display: block;
}
.hide-err {
  display: none;
}
.article-link {
  display: block;
  color: #3bb4ef;
}
.article-link:focus {
  outline: none;
}

.footer__modal-exit-icon {
  position: absolute;
  right: 10px;
  top: 8px;
  font-weight: 500;
  cursor: pointer;
}
.footer__item {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  text-align: center;
  margin: 0;
  padding: 1rem 0 1rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  h4 {
    font-family: Roboto, Helvetica, Arial, sans-serif;
  }
}
.footer__item-wrapper {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 50px;
  @media screen and (min-width: 542px) {
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    margin-bottom: 90px;
  }
}
.footer__item--first {
  display: flex;
  font-size: 18px;
  align-self: flex-start;
}
.footer__item--second {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  @media screen and (min-width: 542px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
}

.footer__line {
  width: 100%;
  height: 1px;
  background-color: grey;
  @media screen and (min-width: 542px) {
    width: 70%;
  }
  @media screen and (min-width: 820px) {
    width: 50%;
  }
}
.footer__item--third {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  @media screen and (min-width: 542px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
}
.footer__item__link {
  color: #736257;
  font-weight: 600;
  text-transform: uppercase;
  justify-content: center;
  align-items: baseline;
  display: flex;
  text-decoration: none;
  -webkit-appearance: none;
  background-color: #fff;
  cursor: pointer;
  text-align: left;
  border: 1px solid #b4b4b4;
  position: relative;
  width: 200px;
  .text {
    font-weight: 600;
    margin: 0;
    transition: 0.4s ease all;
    animation-delay: 0.6s;
    padding: 15px 0px;
    font-size: 1rem;
    text-align: center;
    width: 100%;
    @media screen and (min-width: 641px) {
      padding: 10px 20px;
      width: auto;
      font-size: 1rem;
    }
  }
  .icon {
    // margin-right: 0.5em;
    margin-right: 5px;
    polyline,
    path {
      stroke: $theme-highlight;
    }
  }
  &:hover {
    background-color: #3ab3ee;
    color: white;
  }
  &:focus {
    outline: -webkit-focus-ring-color auto 0px;
  }
}
.footer__title {
  font-size: 2rem;
  font-weight: 700;
  color: #2b2b2b;
  padding: 0;
  margin: 0;
  margin-bottom: 30px;
  text-align: center;
  @media screen and (min-width: 542px) {
    text-align: center;
  }
}
.footer__subtitle {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2b2b2b;
  padding: 0;
  margin: 0;
  margin-bottom: 20px;
}
.footer__text {
  font-size: 17px;
  font-weight: 300;
  line-height: 28px;
  color: #221f1f;
  padding: 0;
  margin: 0;
  margin-bottom: 30px;
  text-align: center;
  @media screen and (min-width: 542px) {
    text-align: center;
  }
}
.footer__modal-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #2b2b2b;
  text-align: start;
  padding: 0 20px 0 20px;
}
.footer__modal-subtitle {
  font-size: 1rem;
  font-weight: 400;
  color: #2b2b2b;
  text-align: start;
  padding: 0px 20px 10px 20px;
  &:last-of-type {
    padding: 0px 20px 0px 20px;
  }
}
.footer__modal-link {
  text-decoration: none;
}
.footer__modal-link-text {
  font-size: 1rem;
  list-style: none;
  width: 100%;
  min-height: 60px;
  background-color: #3ab3ee;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 400;
  transition: 0.4s ease all;
  animation-delay: 0.6s;
  margin-bottom: 10px;
  &:hover {
    background-color: rgba($color: #3ab3ee, $alpha: 0.7);
  }
}
.footer__modal-options {
  padding: 0;
}
.footer__modal-option {
  text-decoration: none;
  font-size: 1rem;
  list-style: none;
  width: 100%;
  position: relative;
  min-height: 40px;
  background-color: #fff;
  transition: 0.4s ease all;
  animation-delay: 0.6s;
  text-align: left;
  border-bottom: 2px solid #000;
  &:first-of-type {
    border-top: 2px solid #000;
  }
  &:nth-child(4) {
    border-top: 2px solid #000;
  }
  &:hover {
    background-color: #f7f3f3;
    &::after {
      transform: scale(1.5);
    }
  }
  &::after {
    content: '>';
    color: #3ab3ee;
    font-size: 20px;
    position: absolute;
    font-weight: 500;
    right: 10px;
    top: calc(50% - 15px);
    transition: 0.4s ease all;
  }
}
.footer__modal-option a {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  color: #2a2a2a;
  font-size: 1rem;
  font-weight: 400;
  text-decoration: none;
  cursor: pointer;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.footer__body {
  background: #2a2a2a;
  padding: 1rem 0;
  line-height: 1rem;
  min-height: 180px;
  .list {
    font-size: 1.15rem;
    li {
      margin-right: 16px;
      .link {
        color: #fff;
        font-weight: 600;
      }
      .link:hover {
        color: lightgray;
        font-weight: 600;
      }
    }
  }
}
.footer__body__inner {
  max-width: 50rem;
  .text {
    font-size: 0.9em;
    color: #676767;
  }
  .link {
    color: $theme-highlight;
    text-decoration: underline;
  }
}
.footer__item__modal {
  position: absolute;
  background: #fff;
  padding: 8px 8px 8px 8px;
  width: 340px;
  border: 2px solid #000;
  border-radius: 6px;
  left: 0;
  bottom: 140px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px,
    rgba(17, 17, 26, 0.1) 0px 24px 80px;
  .link {
    color: $theme-highlight;
  }
  @media (min-width: 641px) {
    bottom: 90px;
  }
}
.footer__item__modals {
  position: absolute;
  background: #eeeded;
  padding: 8px 0px 8px 0px;
  width: 340px;
  border: 2px solid #000;
  border-radius: 6px;
  left: 0;
  bottom: 140px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px,
    rgba(17, 17, 26, 0.1) 0px 24px 80px;
  .link {
    color: $theme-highlight;
  }
  @media (min-width: 641px) {
    bottom: 90px;
  }
  @media (min-width: 1000px) {
    right: -30%;
  }
  @media (min-width: 1300px) {
    right: -50%;
  }
  @media (min-width: 1600px) {
    right: -70%;
  }
}
</style>
